import HttpClient from "./HttpClient";
import { saveAlertMessage } from "../screens/redux/slice/alertMessage";
import store from "../screens/redux/store/store";
import toast from "react-hot-toast";

const notify = (msg) => {
  if (msg) {
    toast.error(msg);
    store.dispatch(saveAlertMessage(msg));
  }
};

// FOR ERROR HANDLE
const HandleException = (err) => {
  console.log("from HandleException", err);

  try {
    const resp = err?.response;
    if (resp?.data) {
      const { data, status } = resp;

      switch (status) {
        case 400:
          notify(data?.message || data?.detail || "Bad request");
          return data || {};
        case 401:
          notify("You have already logged in on another device");
          setTimeout(() => {
            localStorage?.clear();
            window.location.reload();
          }, 2000);
          return {};
        case 404:
          notify("Page Not Found");
          return {};
        default:
          notify(data?.message || "Something went wrong");
          return data || {};
      }
    } else {
      notify("Something went wrong or check your internet");
      return {};
    }
  } catch (error) {
    notify("Something went wrong or check your internet");
    return {};
  }
};

// ✅ Response formatter
const PrepareResponse = (res) => {
  if (res?.status >= 200 && res?.status < 300) {
    return res.data;
  }
  notify(res?.data?.message || "Unexpected error");
  return {};
};

// ✅ API Methods
export const post = async (url, data) => {
  try {
    let res = await HttpClient.post(url, data);
    return PrepareResponse(res);
  } catch (error) {
    return HandleException(error);
  }
};

export const get = async (url) => {
  try {
    let res = await HttpClient.get(url);
    return PrepareResponse(res);
  } catch (error) {
    return HandleException(error);
  }
};

export const deletes = async (url) => {
  try {
    let res = await HttpClient.delete(url);
    return PrepareResponse(res);
  } catch (error) {
    return HandleException(error);
  }
};

export const file_post = async (url, data) => {
  try {
    let res = await HttpClient.post(url, data, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return PrepareResponse(res);
  } catch (error) {
    return HandleException(error);
  }
};
